import { Link } from 'react-router-dom'
import './Features.css'

const Features = ({ 
  title = "Nuestros Servicios",
  subtitle = "Soluciones contables integrales para tu empresa",
  features = [],
  showCTA = true 
}) => {
  const defaultFeatures = [
    {
      icon: "📊",
      title: "Contabilidad General",
      description: "Llevamos la contabilidad completa de tu empresa con precisión y profesionalismo.",
      link: "/servicios"
    },
    {
      icon: "📋",
      title: "Asesoramiento Impositivo",
      description: "Te ayudamos a cumplir con todas las obligaciones fiscales de manera eficiente.",
      link: "/servicios"
    },
    {
      icon: "💰",
      title: "Liquidación de Sueldos",
      description: "Cálculo preciso de salarios, aportes y contribuciones para tus empleados.",
      link: "/servicios"
    },
    {
      icon: "🏢",
      title: "Consultoría Empresarial",
      description: "Asesoramiento estratégico para optimizar la gestión de tu empresa.",
      link: "/servicios"
    }
  ]

  const featuresToShow = features.length > 0 ? features : defaultFeatures

  return (
    <section className="features">
      <div className="container">
        <div className="features__header">
          <h2 className="features__title">{title}</h2>
          <p className="features__subtitle">{subtitle}</p>
        </div>
        
        <div className="features__grid">
          {featuresToShow.map((feature, index) => (
            <div key={index} className="features__card">
              <div className="features__card-icon">
                {feature.icon}
              </div>
              <h3 className="features__card-title">{feature.title}</h3>
              <p className="features__card-description">{feature.description}</p>
              {feature.link && (
                <Link to={feature.link} className="features__card-link">
                  Más información →
                </Link>
              )}
            </div>
          ))}
        </div>
        
        {showCTA && (
          <div className="features__cta">
            <Link to="/servicios" className="features__cta-button">
              Ver Todos los Servicios
            </Link>
          </div>
        )}
      </div>
    </section>
  )
}

export default Features
